import theme from "assets/theme";
import PressableContainer from "formElements/PressableContainer.component";
import React, { useState } from "react";
import { Modal, StyleSheet, Text, View } from "react-native";

const classes = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    backgroundColor: theme.color.white,
    borderRadius: 10,
    padding: 20,
    width: 400,
  },
  header: {
    fontSize: 22,
    fontWeight: theme.font.weight.medium,
    color: theme.color.primary,
    marginBottom: 12,
    textAlign: "center",
  },
  orgButton: {
    borderRadius: 8,
    padding: 12,
    marginTop: 8,
    position: "relative",
    cursor: "pointer",
  },
  orgButtonHovered: {
    backgroundColor: theme.color.grey,
    borderRadius: 8,
    padding: 12,
    marginTop: 8,
    position: "relative",
    cursor: "pointer",
    opacity: 0.7,
  },
  orgText: {
    color: theme.color.darkGrey,
    textAlign: "center",
    fontSize: 16,
  },
  orgTextHovered: {
    color: theme.color.darkGrey,
    textAlign: "center",
    fontSize: 16,
  },
  alertBadge: {
    backgroundColor: theme.color.red,
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 2,
    minWidth: 24,
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 4,
    right: 4,
  },
  alertCount: {
    color: theme.color.white,
    fontSize: 12,
    fontWeight: theme.font.weight.medium,
  },
  buttonText: {
    color: theme.color.primary,
    textAlign: "center",
    fontSize: 16,
  },
});

export default function SelectOrganizationModal(props) {
  const { visible, organizations, onSelect, onClose } = props;
  const [hoveredOrgId, setHoveredOrgId] = useState(null);

  return (
    <Modal transparent visible={visible} animationType="fade">
      <View style={classes.backdrop}>
        <View style={classes.container}>
          <Text style={classes.header}>Select Organization</Text>
          {organizations.map((org) => (
            <PressableContainer
              key={org.organizationId}
              style={
                hoveredOrgId === org.organizationId
                  ? classes.orgButtonHovered
                  : classes.orgButton
              }
              onPress={() => onSelect(org)}
              onMouseEnter={() => setHoveredOrgId(org.organizationId)}
              onMouseLeave={() => setHoveredOrgId(null)}
            >
              <Text
                style={
                  hoveredOrgId === org.organizationId
                    ? classes.orgTextHovered
                    : classes.orgText
                }
              >
                {org.name}
              </Text>
              <View style={classes.alertBadge}>
                <Text style={classes.alertCount}>
                  {org.alerts} {org.alerts === 1 ? "Alert" : "Alerts"}
                </Text>
              </View>
            </PressableContainer>
          ))}
          <PressableContainer onPress={onClose} style={classes.orgButton}>
            <Text style={classes.buttonText}>Cancel</Text>
          </PressableContainer>
        </View>
      </View>
    </Modal>
  );
}
